import React, {PropTypes} from 'react';
import {API} from '../../settings.js';
import {ajaxGet} from '../../helpers/apiData.js';
import PreLoader from "../PreLoader";
import {imagesLoaded} from "../../helpers/imagesLoadCheck";

//import Slider from 'react-slick';

class About extends React.Component {
  static propTypes = {
    background: PropTypes.string,
    match: PropTypes.object,
    name: PropTypes.string,
    view_info: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.addThis = '';

    this.state = {
      loading: 'loading',
      data: {gallery: [], description: '', name: ''},
      detail_width: 0
    };

    this.handleLoading = this.handleLoading.bind(this);
    this.updateDimensions = this.updateDimensions.bind(this);

  }

  componentDidMount() {
    this.lang = this.props.match.params.lang;
    this.restaurant = this.props.match.params.restaurant;

    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions);
    ajaxGet(API + this.lang + '/api/restaurant/' + this.restaurant + '/about/', this);
    this.handleLoading();

  }

  shouldComponentUpdate(nextProps, nextState) {
    return (this.props.name !== nextProps.name || this.state !== nextState);
  }



  componentDidUpdate(prevState) {
    // Sending view info to Restaurant.js to feed the Top and Bottom bars
    if (this.state.data.name) {
      this.props.view_info(
        this.state.data.name,
        'about',
        false
      );
    }
    //NEED THIS TO FORCE ADDTHIS TO LOAD
    if (prevState.addthis !== this.addThis) {
      // eslint-disable-next-line
      if (typeof addthis.layers.refresh !== 'undefined') {
        // eslint-disable-next-line
        addthis.layers.refresh();
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  handleLoading() {
    this.setState({
      loading: imagesLoaded(this.list),
    });
  }


  updateDimensions() {
    if (window.innerWidth > 1024) {
      this.setState({detail_width: window.innerWidth - 120});
    }
    else {
      this.setState({detail_width: window.innerWidth});
    }
  }

  render() {
    return (
      <div>
        <PreLoader loading={this.state.loading}/>

        <div className={`item-detail content-wrapper about ${this.state.loading}`}
             style={{width: this.state.detail_width}}>
          <div className="detail-half">
            <div className="card main-card">
              <div className="list-item" ref={(el) => this.list = el}>
                {this.props.background ? <img className="hero-image" src={this.props.background} alt=""/> : null}
              </div>
            </div>
          </div>

          <div className="detail-half">
            <div className="card">
              <h5 className="item-title">{this.state.data.name}</h5>
              <div ref="addthis" className="addthis_inline_share_toolbox"/>
              <div dangerouslySetInnerHTML={{ __html: this.state.data.description}}></div>
            </div>
          </div>
          {/*this.state.data.gallery.length > 0
            ?
              <div className="detail-half">
                <div className="gallery">
                  <div className='slider-container'>
                    <Slider {...settings}>
                      {listImages}
                    </Slider>
                  </div>

                </div>
              </div>
              : null
            */}
        </div>
      </div>
    );
  }
}

export default About;



/** WEBPACK FOOTER **
 ** ./src/components/restaurant/About.js
 **/